/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_AD as AD,
  rec_JSXRuntime as JSXRuntime,
  rec_RD as RD,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_Xx as Xx,
  rec_Yx as Yx,
  rec_Zx as Zx,
  rec_fS as fS,
} from "../../runtime/index.jsx";
export function Componente_LD_76_68(e) {
  let t = (0, ReactCompiler.c)(9),
    { tareas: n, listas: r, onCard: i } = e,
    a;
  t[0] !== r || t[1] !== n
    ? ((a = new Map()),
      a.set(AD, []),
      r.forEach((e) => a.set(String(e.id), [])),
      n.forEach((e) => {
        let t = e.listaId ? String(e.listaId) : AD;
        (a.has(t) || a.set(t, []), a.get(t).push(e));
      }),
      (t[0] = r),
      (t[1] = n),
      (t[2] = a))
    : (a = t[2]);
  let o = a,
    s;
  t[3] === r
    ? (s = t[4])
    : ((s = (e) =>
        e === AD
          ? `Sin lista`
          : (r.find((t) => String(t.id) === e)?.nombre ?? e)),
      (t[3] = r),
      (t[4] = s));
  let c = s,
    l;
  return (
    t[5] !== o || t[6] !== c || t[7] !== i
      ? ((l = (
          <div
            className={`flex flex-col gap-4`}
            children={[...o.entries()].filter(RD).map((e) => {
              let [t, n] = e;
              return (
                <div
                  key={t}
                  children={[
                    <p
                      className={`mb-1 text-xs font-semibold uppercase tracking-wide text-(--text)`}
                      children={[c(t), ` · `, n.length]}
                    />,
                    <ul
                      className={`flex flex-col gap-1`}
                      children={n.map((e) => (
                        <li
                          key={e.id}
                          children={
                            <button
                              type={`button`}
                              onClick={() => i(e)}
                              className={`flex w-full flex-wrap items-center gap-2 rounded-xl border border-(--border) bg-(--bg) px-3 py-2 text-left transition hover:shadow-(--shadow)`}
                              children={[
                                <span
                                  className={`min-w-0 flex-1 truncate text-sm text-(--text-h)`}
                                  children={e.titulo}
                                />,
                                <span
                                  className={`rounded-full px-1.5 py-0.5 text-[10px] ${Zx(e.prioridad)}`}
                                  children={Yx(e.prioridad)}
                                />,
                                <span
                                  className={`rounded-full bg-(--panel) px-1.5 py-0.5 text-[10px] text-(--text)`}
                                  children={Yx(e.estado)}
                                />,
                                e.fechaVencimiento && (
                                  <span
                                    className={`text-[11px] ${e.atrasada ? `text-(--error)` : `text-(--text)`}`}
                                    children={fS(e.fechaVencimiento)}
                                  />
                                ),
                                Xx(e) && (
                                  <span
                                    className={`text-[11px] text-(--text)`}
                                    children={Xx(e)}
                                  />
                                ),
                              ]}
                            />
                          }
                        />
                      ))}
                    />,
                  ]}
                />
              );
            })}
          />
        )),
        (t[5] = o),
        (t[6] = c),
        (t[7] = i),
        (t[8] = l))
      : (l = t[8]),
    l
  );
}
